import { CommonUploadFilesItemProp } from '@/website/components/uploadFiles/common';
import { SwitchToJovePayloadData } from '@jove-frontend/uikit';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export type ImportQuoteDetailInfo = {
  id: string;
  isCreateNewImportQuote?: boolean;
  extractData?: SwitchToJovePayloadData;
};

export interface UploadFileExtractQuoteStoreState {
  policyScheduleFiles: CommonUploadFilesItemProp[];
  importQuoteDetailInfo: ImportQuoteDetailInfo;
}

export interface UploadFileExtractQuoteStoreActions {
  updatePolicyScheduleFiles: (files: CommonUploadFilesItemProp[]) => void;
  updateImportQuoteDetailInfo: (data: ImportQuoteDetailInfo) => void;
  cleanImportExtractQuoteRelatedInfo: () => void;
}

export interface UploadFileExtractQuoteStore {
  state: UploadFileExtractQuoteStoreState;
  actions: UploadFileExtractQuoteStoreActions;
}

export const useUploadFileExtractQuoteStore =
  create<UploadFileExtractQuoteStore>()(
    immer((set, get) => ({
      state: {
        policyScheduleFiles: [],
        importQuoteDetailInfo: {
          id: null,
          isCreateNewImportQuote: true,
          extractData: null,
        },
      },
      actions: {
        updatePolicyScheduleFiles: (files) => {
          set((store) => {
            store.state.policyScheduleFiles = files;
          });
        },
        cleanImportExtractQuoteRelatedInfo: () => {
          set((store) => {
            store.state.policyScheduleFiles = [];
            store.state.importQuoteDetailInfo = {
              id: null,
              isCreateNewImportQuote: true,
              extractData: null,
            };
          });
        },
        updateImportQuoteDetailInfo: (data) => {
          set((store) => {
            store.state.importQuoteDetailInfo = {
              ...store.state.importQuoteDetailInfo,
              ...data,
            };
          });
        },
      },
    }))
  );
